import { render } from "./html-chapter-3.vue?vue&type=template&id=7639c639"
import script from "./html-chapter-3.vue?vue&type=script&lang=js"
export * from "./html-chapter-3.vue?vue&type=script&lang=js"

import "./html-chapter-3.vue?vue&type=style&index=0&id=7639c639&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__